import { ref } from "vue";

export function useTimer() {
  const timer = ref<ReturnType<typeof setInterval> | null>(null);

  const startInterval = (duration: number, onTick: () => void) => {
    if (timer.value) {
      clearInterval(timer.value);
    }
    timer.value = setInterval(onTick, duration);
  };

  const stopInterval = () => {
    if (timer.value) {
      clearInterval(timer.value);
      timer.value = null;
    }
  };

  const isRunning = () => timer.value !== null;

  return { startInterval, stopInterval, isRunning };
}
